export default __webpack_public_path__ + "static/media/1.79b73380.JPG";